/* eslint-disable array-callback-return */
import * as Constants from '../utils/constants';

const initialState = {
  loading: false,
  data: null,
  success: false,
  error: false,
  error_msg: '',
};

const SpecificReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.START_SPECIFIC: {
      return {
        ...state,
        loading: true,
      };
    }
    case Constants.SPECIFIC_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    }
    case Constants.SPECIFIC_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };
    }
    
    case Constants.SPECIFIC_RESET: {
      return {
        ...state,
        loading: false,
        error: false,
        error_msg: '',
        success: false,
        data: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default SpecificReducer;
